import type { TFunction } from "i18next";
import type { DefinitionProblem } from "../api/content/authoring/processAuthoringApi";

/** Field checks with words of their own, `errors.definition.<check>`; a bounded one counts its bound. */
const WORDED_CHECKS: Readonly<Record<string, "plain" | "bounded">> = {
  missing: "plain",
  string_pattern_mismatch: "plain",
  string_too_short: "bounded",
  string_too_long: "bounded",
  too_short: "bounded",
  too_long: "bounded",
};

/**
 * What a definition problem says to a person (NFR-5, TB2-02): a field check in the reader's
 * language, with its bound, and any other field check as not valid; a rule in the sentence
 * module B wrote for it. A validator's English never reaches the screen.
 */
export function definitionProblemText(problem: DefinitionProblem, t: TFunction): string {
  if (problem.check === null) return problem.message;
  const worded = WORDED_CHECKS[problem.check];
  if (worded === undefined || (worded === "bounded" && problem.limit === null)) return t("errors.definition.invalid");
  return worded === "bounded" ? t(`errors.definition.${problem.check}`, { count: problem.limit }) : t(`errors.definition.${problem.check}`);
}
